import Head from 'next/head';
import parse from 'html-react-parser';
import axios from 'axios';
import { contentApi } from '../../utils/journal';
import styles from '../../styles/Editorial.module.scss';
export default function About({ about }) {
  return <div className={styles.page}><Head><title>{about.meta_title}</title><meta name="description" content={about.meta_description} /><meta name="keywords" content={about.keywords} /><link rel="canonical" href="https://ammohawk.com/about" /></Head><article className={styles.article}><p className={styles.eyebrow}>Prices · Brands · The ammunition business</p><h1>About AmmoHawk</h1><div className={styles.body}>{parse(about.content)}</div></article></div>;
}
export async function getStaticProps() {
  const { data } = await axios.get(`${contentApi}/about/`, { timeout:20000 });
  if (!data[0]) throw new Error('About content unavailable');
  return { props:{ about:data[0] }, revalidate:300 };
}
